module.exports = __webpack_public_path__ + "img/star.af7029e1.png";